export const PRODUCT_HOST = 'http://paolashopping.com/apis/storage/media/Products/'